<template v-if="associate">
  <div class="wrapper">
    <h3>Personal</h3>
    <a-descriptions :column="1" size="small" class="col-fixed p-0">
      <a-descriptions-item label="Email">
        {{ associate.email }}
      </a-descriptions-item>
      <a-descriptions-item label="Phone">
        {{ associate.phone }}
      </a-descriptions-item>
      <a-descriptions-item :label="getTaxIdentifierLabel(associate.is_ssn)">
        {{ associate.social_security_number ?? ' - ' }}
      </a-descriptions-item>
      <a-descriptions-item label="Birth Date">
        {{ associate.birth_date ? formatDateString(associate.birth_date) : ' - ' }}
      </a-descriptions-item>
    </a-descriptions>

    <h3>Payment</h3>
    <a-descriptions :column="1" size="small" class="col-fixed p-0">
      <a-descriptions-item label="Type">
        {{ associate.payment_info.type }}
      </a-descriptions-item>
      <template v-if="associate.payment_info.legal_entity">
        <a-descriptions-item label="Subtype">
          {{ AGENCY_TYPES[associate.payment_info.legal_entity.type] }}
        </a-descriptions-item>
        <a-descriptions-item label="Legal Entity">
          {{ associate.payment_info.legal_entity.name }}
        </a-descriptions-item>
      </template>

      <a-descriptions-item label="Status">
        {{ getPaymentStatus(associate.payment_info.status) }}
      </a-descriptions-item>
      <a-descriptions-item label="Method">
        {{ getPaymentMethod(associate.payment_info.method) }}
      </a-descriptions-item>
      <a-descriptions-item label="Hourly Rate, $">
        {{ formatRate(associate.payment_info.hourly_rate) }}
      </a-descriptions-item>
      <a-descriptions-item v-if="associate.payment_info.method === 'salary'" label="Salary for Pay Period, $">
        {{ formatRate(associate.payment_info.salary) }}
      </a-descriptions-item>
      <a-descriptions-item label="Orientation Rate, $">
        {{ formatRate(associate.payment_info.orientation_rate) }}
      </a-descriptions-item>
      <a-descriptions-item label="Training Rate, $">
        {{ formatRate(associate.payment_info.training_rate) }}
      </a-descriptions-item>
      <a-descriptions-item label="Allow Instant Payment">
        {{ associate.allow_instant_payment ? 'Allow' : 'Forbid' }}
      </a-descriptions-item>
      <a-descriptions-item label="Auto Approve Invoice">
        {{ associate.payment_auto_approve ? 'Allow' : 'Forbid' }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { AGENCY_TYPES } from '@/store/modules/legal-entity/constants'
import { PAYMENT_METHOD, PAYMENT_WORK_STATUS } from '@/store/modules/payment/constants'
import { Descriptions } from 'ant-design-vue'
import moment from 'moment-timezone'
import { getTaxIdentifierLabel } from '@/utils/tax-identifier'

export default {
  name: 'SequenceReviewInfo',
  components: {
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item
  },
  data() {
    return {
      AGENCY_TYPES
    }
  },
  props: {
    associate: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getPaymentMethod(method) {
      return PAYMENT_METHOD[method]
    },
    getPaymentStatus(status) {
      return PAYMENT_WORK_STATUS[status]
    },
    formatDateString(dateString) {
      return moment(dateString).utc().format('MM/DD/YYYY')
    },
    getTaxIdentifierLabel,
    formatRate(rate) {
      return typeof rate === 'number' ? rate / 100 : ' - '
    }
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 360px;
  overflow: auto;
}
</style>
